<template>
	<div class="w-full">
		<Disclosure
			v-for="tab in tabs"
			:key="
				tab.value === ProductDetailsTabs.REVIEWS
					? `${tab.value}-${reviewsOpenRequest}`
					: tab.value
			"
			v-slot="{ open }"
			:default-open="currentTabHash === tab.value"
			as="div"
		>
			<DisclosureButton
				:id="`button-${tab.value}`"
				class="flex justify-between w-full p-4 text-left border-t focus:outline-none scroll-mt-32"
				@click="changeTab(tab.value)"
			>
				<span>{{ $t(tab.name) }}</span>
				<ChevronDownIcon
					:class="[
						open ? 'rotate-180' : '',
						'h-6 w-6 transition-transform duration-200'
					]"
				/>
			</DisclosureButton>
			<DisclosurePanel :id="`panel-${tab.value}`" class="p-4">
				<div
					v-if="tab.value === ProductDetailsTabs.DESCRIPTION"
					class="prose prose-sm max-w-none"
					v-html="description"
				></div>
				<div
					v-else-if="tab.value === ProductDetailsTabs.SPECIFICATION"
					class="flex flex-col"
				>
					<div
						v-for="parametric in currentTabSpecification"
						:key="parametric.Id"
						class="flex justify-between py-4 border-b border-gray-dark last:border-b-0"
					>
						<span>{{ parametric.Name }}</span>
						<span>{{ parametric.Value }}</span>
					</div>
				</div>
				<div
					v-else-if="tab.value === ProductDetailsTabs.SIZE_GUIDE"
					class="mt-2"
				>
					<NuxtImg
						v-if="sizeGuideImage"
						:src="sizeGuideImage.filename"
						:alt="sizeGuideImage.alt || 'Size guide'"
						provider="storyblok"
						class="w-full"
					/>
				</div>
				<div
					v-else-if="tab.value === ProductDetailsTabs.WASHING_INSTRUCTIONS"
					class="mt-2"
				>
					<NuxtImg
						v-if="washingInstructionImage"
						:src="washingInstructionImage.filename"
						:alt="washingInstructionImage.alt || 'Washing instructions'"
						provider="storyblok"
						class="w-full"
					/>
				</div>
				<div v-else-if="tab.value === ProductDetailsTabs.REVIEWS" class="mt-2">
					<ProductLipscoreProductReviews />
				</div>
			</DisclosurePanel>
		</Disclosure>
	</div>
</template>

<script setup lang="ts">
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";
import { ChevronDownIcon } from "@heroicons/vue/24/outline";
import type { VariantParametric } from "@nwt/norce-pwa/dist/runtime/types/api/product/product";
import type { Image } from "~/types/storyblok/storyblok";

interface Props {
	tabs: { name: string; value: string }[];
	currentTabHash: string;
	changeTab: (value: string) => string;
	description: string | undefined;
	currentTabSpecification: VariantParametric[] | undefined;
	sizeGuideImage?: Image;
	washingInstructionImage?: Image;
	/** Changes when the review link asks to open Reviews; remounts that panel open. */
	reviewsOpenRequest?: number;
}

defineProps<Props>();
</script>
